import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ContextService } from "@maximizer/core/shared/data-access";
import { Observable, map } from "rxjs";
import { Octopus } from '@maximizer/core/shared/domain';

interface EmailMessageResponse extends Octopus.Response {
  EmailMessage: Octopus.WriteResponse<EmailMessage>;
}

export interface EmailMessageRequest {
  EmailMessage: Octopus.WriteRequest<EmailMessage>;
}

export interface EmailMessage {
  From: string;
  To: string[];
  Subject: string;
  Type: number;
  Body: string;
}

@Injectable()
export class EmailService {

  constructor(
    private readonly http: HttpClient,  
    private readonly context: ContextService,
  ) {}

  sendSuggestion(request: EmailMessageRequest): Observable<EmailMessage | undefined> {
    return this.http
      .post<EmailMessageResponse>(
        `${this.context.api}${Octopus.Action.CREATE}`,
        request,
      )
      .pipe(
        map((result) => {
          if (result.Code === Octopus.ResponseStatusCode.Successful) {
            return result.EmailMessage.Data;
          }
          return undefined;
        }),
      );
  }
}